import { canHandleRoute, getRoutingComponent } from 'supertokens-auth-react/ui';
import { PasswordlessPreBuiltUI } from 'supertokens-auth-react/recipe/passwordless/prebuiltui';
import { Logo } from '@sara/ui/components/logo';

export function AuthPage() {
  if (!canHandleRoute([PasswordlessPreBuiltUI])) {
    return null;
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-md space-y-8 px-6 py-16">
        <div className="flex flex-col items-center gap-6 text-center">
          <Logo className="h-14 w-14" />
          <div className="space-y-3">
            <h1 className="font-display text-3xl font-medium tracking-tight text-foreground">
              Sign in to AI Interviewer
            </h1>
            <p className="text-[15px] leading-relaxed text-muted-foreground">
              Enter your work email and we&apos;ll send a one-time link to continue.
            </p>
          </div>
        </div>
        <div>{getRoutingComponent([PasswordlessPreBuiltUI])}</div>
      </div>
    </div>
  );
}
